import { gameAccountRoute, GAME_ACCOUNT_BY_ROUTE } from '../../../games/shared/game-account/game-account.config';
import { GameEngineApiService } from '../../../Services/game-engine-api.service';
import {
  Component,
  ViewEncapsulation,
  ElementRef,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import { CommonModule, NgFor } from '@angular/common';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterModule,
} from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ApiCallService } from '../../../Services/api-call-service.service';
import { ErrorhandlingService } from '../../../Services/error-handling.service';
import { GameCard } from '../../../Interfaces/interfaces';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { LoaderService } from '../../../Services/loader-service.service';
import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import {
  TabNavigationComponent,
  TabItem,
} from '../../../components/tab-navigation/tab-navigation.component';
import { UtilsService } from '../../../Services/utils.service';
import { HotGamesService } from '../../../Services/hot-games.service';
import { LotteryCardComponent } from '../../lottery/lottery-card/lottery-card.component';
import { LotteryCardsComponent } from '../../../components/lottery-cards/lottery-cards.component';
import { SectrechCardListComponent } from '../../../dashboard/Sectrech Cards/sectrech-card-list/sectrech-card-list.component';
import { LotteryWinnersComponent } from '../lottery-winners/lottery-winners.component';
import { LotteryLandingComponent } from '../lottery-landing/lottery-landing.component';
import { GamePromoBannerComponent } from '../game-promo-banner/game-promo-banner.component';
import { LandingCaroselComponent } from '../landing-carosel/landing-carosel.component';
import { ShiningStarsOfGamesComponent } from '../shining-stars-of-games/shining-stars-of-games.component';
import { OnBoardingStepsComponent } from '../on-boarding-steps/on-boarding-steps.component';
import { SpinComponent } from '../spin/spin.component';
import { AboutUsComponent } from '../about-us/about-us.component';
import { JoinCommunityComponent } from '../join-community/join-community.component';
import { filter, Subject, Subscription, takeUntil } from 'rxjs';
import { SpinnerComponent } from '../../../components/spinner/spinner.component';
import { GameService } from '../../../Services/game.service';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@Component({
  selector: 'app-games-landing',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgFor,
    FontAwesomeModule,
    RouterModule,
    TabNavigationComponent,
    LotteryCardsComponent,
    SectrechCardListComponent,
    LotteryWinnersComponent,
    LotteryLandingComponent,
    OnBoardingStepsComponent,
    SpinComponent,
    JoinCommunityComponent,
    AboutUsComponent,
    SpinnerComponent,
    NgxSkeletonLoaderModule,
  ],
  templateUrl: './games-landing.component.html',
  styleUrl: './games-landing.component.scss',
})
export class GamesLandingComponent {
  private readonly destroy$ = new Subject<void>();
  scoreForm!: FormGroup;
  scoreCaptchaForm!: FormGroup;
  searchTerm: string = '';
  instantSearchTerm: string = '';
  selectedMainTab: string = 'games';
  isLandingPage: boolean = true;
  // selectedLotteryTab: string = 'lotteries';

  mainTabs: TabItem[] = [
    { id: 1, label: 'Games', value: 'games', scrollingId: 'games-scroll-id' },
    {
      id: 2,
      label: 'Quick Games',
      value: 'quick',
      scrollingId: 'quick-scrolling-id',
    },
    // {
    //   id: 3,
    //   label: 'Lotteries',
    //   value: 'lotteries',
    //   scrollingId: 'lottriesScrollSection',
    // },
    {
      id: 4,
      label: 'Scratch Cards',
      value: 'scratch-cards',
      scrollingId: 'scratchScrollSection',
    },
    { id: 5, label: 'Spin', value: 'spin', scrollingId: 'spin-scrolling-id' },
  ];

  displayMainTabs: TabItem[] = [];

  lotteryTab: TabItem[] = [{ id: 2, label: 'Lotteries', value: 'lotteries' }];

  ScratchTab: TabItem[] = [
    { id: 3, label: 'Scratch Cards', value: 'Scratch Cards' },
  ];

  SpinnerTab: TabItem[] = [
    { id: 4, label: 'Spin', value: 'spin', scrollingId: 'spin-scrolling-id' },
  ];

  QuickgameTab: TabItem[] = [
    {
      id: 1,
      label: 'Quick Games',
      value: 'quick',
      scrollingId: 'quick-scrolling-id',
    },
  ];

  quickGames: any[] = [
    {
      id: 5,
      name: 'Aviator',
      image: 'https://imagesdeployed.pages.dev/assets/Avaitar.png',
      redirectLink: '/dashboard/aviator',
      color: '#00dbde',
    },
    {
      id: 6,
      name: 'Baccarat',
      image: 'https://imagesdeployed.pages.dev/assets/Baccarat.png',
      redirectLink: '/dashboard/baccarat',
      color: '#00dbde',
    },
    {
      id: 4,
      name: 'Treasure Pick',
      image: 'https://imagesdeployed.pages.dev/assets/treasure-card.png',
      redirectLink: '/dashboard/treasure-pick',
      color: '#00dbde',
    },
    {
      id: 21,
      name: 'Double',
      image: 'https://newimages.pages.dev/Double.png',
      redirectLink: '/dashboard/double',
      color: '#9dbb65',
    },

    {
      id: 8,
      name: 'Mines',
      image: 'https://newimages.pages.dev/mines.png',
      redirectLink: '/dashboard/mines',
      color: '#00dbde',
    },
    {
      id: 9,
      name: 'Plinko',
      image: 'https://newimages.pages.dev/plinko.png',
      redirectLink: '/dashboard/plinko',
      color: '#00dbde',
    },
    {
      id: 22,
      name: 'Toss',
      image: 'https://newimages.pages.dev/toss.png',
      redirectLink: '/dashboard/toss',
      color: '#4277a3',
    },
    {
      id: 23,
      name: 'Slots',
      image: 'https://imagesdeployed.pages.dev/assets/slots.png',
      redirectLink: '/dashboard/slots',
      color: '#f59e0b',
    },
    {
      id: 7,
      name: 'Roulette',
      image: 'https://newimages.pages.dev/roulette.png',
      redirectLink: '/dashboard/roulette',
      color: '#00dbde',
    },
    {
      id: 1,
      name: 'Spin',
      image: 'Images/spin.png',
      redirectLink: '/dashboard/spinner',
      color: '#00dbde',
    },
    {
      id: 10,
      name: 'Stack Builder',
      image: 'https://newimages.pages.dev/stack.png',
      redirectLink: '/dashboard/stack-builder',
      color: '#00dbde',
    },
    {
      id: 11,
      name: 'Keno',
      image: 'https://newimages.pages.dev/keno.png',
      redirectLink: '/dashboard/keno',
      color: '#00dbde',
    },
    {
      id: 3,
      name: 'Scratch',
      image: 'https://imagesdeployed.pages.dev/assets/sactrach.png',
      redirectLink: '/dashboard/scratch',
      color: '#00dbde',
    },
    {
      id: 23,
      name: 'Ace Win',
      image: 'https://iideployed.pages.dev/assets/ace.png',
      redirectLink: '/dashboard/ace-win',
      color: '#00dbde',
    },
    {
      id: 24,
      name: 'Slot 777',
      image: 'https://iideployed.pages.dev/assets/slot777.png',
      redirectLink: '/dashboard/slot-777',
      color: '#00dbde',
    },
    {
      id: 25,
      name: 'Card Brag 3',
      image: 'https://iideployed.pages.dev/assets/3cardbrag.png',
      redirectLink: '/dashboard/card-brag-3',
      color: '#00dbde',
    },
    {
      id: 26,
      name: 'Space Hunt',
      image: 'https://iideployed.pages.dev/assets/space-hunt.png',
      redirectLink: '/dashboard/space-hunt',
      color: '#00dbde',
    },
    {
      id: 27,
      name: 'Lucky Trigger',
      image: 'https://iideployed.pages.dev/assets/lucky-trigger.png', 
      redirectLink: '/dashboard/lucky-trigger',
      color: '#00dbde',
    },
    {
      id: 28,
      name: 'CashBull',
      image: 'https://iideployed.pages.dev/assets/cashbull.png',
      redirectLink: '/dashboard/cashbull',
      color: '#00dbde',
    },
    {
      id: 29,
      name: 'Joker 777',
      image: 'https://iideployed.pages.dev/assets/joker777.png',
      redirectLink: '/dashboard/joker-777',
      color: '#00dbde',
    },
    {
      id: 30,
      name: 'Sum Dice',
      image: 'https://iideployed.pages.dev/assets/dice-roll.png',
      redirectLink: '/dashboard/sum-dice',
      color: '#00dbde',
    },
  ];

  redirectTo(link: string) {
    if (link.startsWith('http')) {
      window.open(link, '_blank');
    } else {
      this.router.navigate([gameAccountRoute(link.replace('/dashboard/', '')) ?? link]);
    }
  }

  quickPlay(game: any) {
    if (!this.isToken) {
      this.redirectToSignUp();
      return;
    }
    this.redirectTo(game.redirectLink);
  }

  constructor(
    public router: Router,
    private route: ActivatedRoute,
    private apiCallService: ApiCallService,
    private errorHandling: ErrorhandlingService,
    private _loaderService: LoaderService,
    private fb: FormBuilder,
    private gameService: GameService,
    private breakpointObserver: BreakpointObserver,
    private _utilsService: UtilsService,
    private engine: GameEngineApiService,
    private hotGamesService: HotGamesService,
    private cdr: ChangeDetectorRef
  ) {
    this.isLandingPage = this.router.url === '/';

    this.routeSub = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd), takeUntil(this.destroy$))
      .subscribe(() => {
        this.checkCurrentRoute();
      });

    // Run once initially
    this.checkCurrentRoute();
    this.filterGames = [...this.allGames];
  }
  AddCaptchaPlayerModal: boolean = false;
  CloseCaptchaAddPlayer() {
    this.AddCaptchaPlayerModal = false;
    this.NewPlayerAddPayload.login_pwd = '';
    this.NewPlayerAddPayload.check_pwd = '';
    this.NewPlayerAddPayload.t = 0;
    this.NewPlayerAddPayload.account = '';
    this.NewPlayerAddPayload.agentcode = '';
  }
  // Games and instant games that carry the HOT tag, shown again in their own section
  get hotGames() {
    return [
      ...this.filteredGames.filter((game: any) => !!game.isHot),
      ...this.filteredQuickGames.filter((game: any) => !!game.isHot),
    ];
  }

  // Shared card button: instant games open their own page, panel games go through the Add Player / credentials flow
  playGame(game: any) {
    if (this.quickGames.includes(game)) {
      if (!game.maintenance) this.quickPlay(game);
      return;
    }
    this.OnPlayNow(game);
  }

  // Tell the sidebar whether to show the "Hot Games" tab
  private lastHotCount = -1;
  ngDoCheck() {
    const count = this.hotGames.length;
    if (count !== this.lastHotCount) {
      this.lastHotCount = count;
      // deferred so the sidebar isn't changed in the middle of a change detection pass
      Promise.resolve().then(() => this.hotGamesService.setHotCount(count));
    }
  }

  get filteredGames() {
    return this.games.filter((game: any) => {
      const matchesSearch =
        !this.searchTerm ||
        game.name.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        game.provider
          .toString()
          .toLowerCase()
          .includes(this.searchTerm.toLowerCase());
      // this.cdr.detectChanges();

      return matchesSearch;
    });
  }

  filterGames: any[] = [];
  allGames: any[] = []; // sab games
  onSearch(): void {
    const term = this.searchTerm.trim().toLowerCase();

    if (term === '') {
      // agar search empty hai to sab games wapas show karo
      this.filterGames = [...this.allGames];
    } else {
      // otherwise filter karo by name
      this.filterGames = this.allGames.filter((game) =>
        game.name.toLowerCase().includes(term),
      );
    }

    // search hone ke baad showAllGames reset kar do (taake limit se start ho)
    this.showAllGames = false;
  }
  // instantSearchTerm: string = '';
  // onInstantSearch(): void {
  //   this.instantSearchTerm = this.instantSearchTerm.trimStart();
  // }

  // get filteredQuickGames() {
  //   const term = this.instantSearchTerm.trim().toLowerCase();
  //   if (!term) {
  //     return this.quickGames;
  //   }
  //   return this.quickGames.filter((game) =>
  //     game.name.toLowerCase().includes(term),
  //   );
  // }

  onInstantSearch(): void {
    this.instantSearchTerm = this.instantSearchTerm.trimStart();
  }

  get filteredQuickGames() {
    const term = this.instantSearchTerm.trim().toLowerCase();
    const visible = this.quickGames.filter((game) => !game.hidden);
    if (!term) {
      return visible;
    }
    return visible.filter((game) => game.name.toLowerCase().includes(term));
  }

  // HOT tag and bonus % on the instant game cards come from the game engine config (set by staff in
  // the admin panel). Hot games are moved to the front; every other card keeps its order.
  private loadInstantGameBadges(): void {
    this.engine.getAllPlayableInfo().pipe(takeUntil(this.destroy$)).subscribe({
      next: (r: any) => {
        if (r?.responseCode !== 200 || !Array.isArray(r.data)) return;
        const byCode = new Map<string, any>(r.data.map((x: any) => [String(x.gameCode ?? x.GameCode).toUpperCase(), x]));

        this.quickGames.forEach((g, i) => { g.order ??= i; });

        for (const game of this.quickGames) {
          const route = String(game.redirectLink || '').replace('/dashboard/', '').toLowerCase();
          const code = GAME_ACCOUNT_BY_ROUTE[route]?.gameCode;
          const cfg = code ? byCode.get(code) : undefined;
          game.isHot = !!(cfg?.isHot ?? cfg?.IsHot);
          // Inactive games disappear; games under maintenance stay but can't be opened.
          game.hidden = !!cfg && (cfg.isActive ?? cfg.IsActive) === false;
          game.maintenance = !!cfg && (cfg.isUnderMaintenance ?? cfg.IsUnderMaintenance) === true;
          const bonus = Number(cfg?.bonusPercentage ?? cfg?.BonusPercentage ?? 0);
          game.bonus = bonus > 0 ? bonus : null;
        }

        // Hot games first; within each group the original card order is kept (so a game that stops
        // being hot drops back to its old spot).
        this.quickGames = [...this.quickGames].sort(
          (a, b) => Number(!!b.isHot) - Number(!!a.isHot) || a.order - b.order,
        );
        this.cdr.detectChanges();
      },
      error: () => { /* cards just show without tags */ },
    });
  }

  games: any[] = [];

  private routeSub!: Subscription;
  ngOnInit() {
    // this.scoreCaptchaForm = this.fb.group({
    //   captchaCode: ['', Validators.required],
    // });
    this.games = this.gameService?.getGames();
    // if (
    //   this._loaderService.getArrayInLocalStorage() &&
    //   this._loaderService.getArrayInLocalStorage()?.length > 0
    // ) {
    //   this.gameAccounts = this._loaderService.getArrayInLocalStorage();
    // } else
    this.getGameNews();
    if (this.isToken) {
      this.getGameAccount(0);
      this.loadInstantGameBadges();
    }
    this.breakpointObserver
      .observe([Breakpoints.Handset])
      .pipe(takeUntil(this.destroy$))
      .subscribe((result: any) => {
        this.isMobileScreen = result.matches;
        this.updateDisplayedTabs();
      });
    this.games.forEach((game: any) => {
      const getPlayerGames = this._loaderService.getArrayInLocalStorage();
      const matchedGame = getPlayerGames.find(
        (matchingGame: any) => matchingGame.GameName === game.name,
      );
      game.buttonText = matchedGame
        ? 'Play Now'
        : game.IsOnUpdate
          ? 'On Update'
          : 'Add Player';
    });
    this.scoreForm = this.fb.group({
      PlayerName: ['', Validators.required],
    });
    this.scoreCaptchaForm = this.fb.group({
      captchaCode: ['', Validators.required],
    });

    this._utilsService.getTriggerOfferHistoryObservable().pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.getGameNews();
      if (this.isToken) this.loadInstantGameBadges();
    });
  }

  updateDisplayedTabs() {
    this.displayMainTabs = this.isMobileScreen
      ? this.mainTabs.slice(0, 2)
      : this.mainTabs;
  }

  toggleShowAllScratch() {
    this.router.navigate(['/dashboard/scratch']);
  }
  checkCurrentRoute() {
    // Get current route path
    const currentUrl = this.router.url;
    const dashboardRoutes = ['/dashboard/home'];
    this.isDashboardPage = dashboardRoutes.some((path) =>
      currentUrl.includes(path),
    );
  }
  visibleGamesCount = 8;
  isDashboardPage: boolean = false;
  @ViewChild('gamesContainer') gamesContainer!: ElementRef;

  showMoreGames() {
    const increment = 4;
    this.visibleGamesCount = Math.min(
      this.visibleGamesCount + increment,
      this.games.length,
    );
  }

  showLessGames() {
    this.visibleGamesCount = 8;
    this.scrollToTop();
  }

  scrollToTop() {
    this.gamesContainer.nativeElement.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  }

  get isToken(): boolean {
    return (
      typeof localStorage !== 'undefined' && !!localStorage.getItem('token')
    ); // returns true if token exists, false otherwise
  }

  redirectToSignUp() {
    const token = localStorage.getItem('token');
    if (token) {
      this.router.navigate(['/dashboard/home']);
    } else {
      this.router.navigate(['/login']);
    }
  }

  ngOnDestroy() {
    if (this.routeSub) this.routeSub.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }
  getGameOffers() {
    this.apiCallService
      .GetCallWithoutToken('Public/GetOfferPercentage')
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response) => {
          if (response && response.responseCode === 200) {
            const apiGameData = response.data;

            this.games.forEach((game: any) => {
              const matchingOffer = apiGameData?.find(
                (offer: any) => offer.GameName === game.name,
              );

              if (matchingOffer) {
                game.offer = matchingOffer.Percentage;
              }
            });
          } else {
            this.errorHandling.handleResponseError(response);
          }
        },
        error: (error) => {
          this.errorHandling.handleHttpError(error);
        },
      });
  }

  private getInitialVisibleCount(): number {
    try {
      const w = window.innerWidth || 0;
      if (w >= 1900) {
        return 20; // lg
      }
      if (w >= 1200) {
        return 13; // lg
      }
      return 5; // small / default
    } catch (e) {
      return 10;
    }
  }

  // Load more / pagination for featured games
  showAllGames: boolean = true;
  get displayedGames() {
    const sortedGames = [...this.filteredGames].sort(
      (a, b) => b.isHot - a.isHot,
    );
    // this.cdr.detectChanges();
    if (this.isToken || this.showAllGames) return sortedGames;
    const count = this.getInitialVisibleCount();
    return sortedGames.slice(0, count);
  }

  // Guarded: the landing page is also rendered on the server, where localStorage doesn't exist.
  getCustomerID(): number | null {
    if (typeof localStorage === 'undefined') return null;
    return Number(localStorage.getItem('customerId'));
  }
  getCustomerName(): string {
    if (typeof localStorage === 'undefined') return '';
    return localStorage.getItem('userName') || '';
  }

  gameOffers: any;
  getGameOffersWithToken() {
    this._loaderService.show();
    this.apiCallService
      .GetCallWithToken(
        'Offer/GetOfferPercentage?customerId=' + this.getCustomerID(),
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response) => {
          if (response && response.responseCode === 200) {
            this.gameOffers = response.data;
            this._loaderService.hide();
            // Assuming `this.games` is the array where you want to patch the Percentage
            this.games.forEach((game: any) => {
              const matchingOffer = this.gameOffers.find(
                (offer: any) => offer.GameName === game.name,
              );
              // const getPlayerGames = this._loaderService.getArrayInLocalStorage();
              // const matchedGame = getPlayerGames.find(
              //   (matchingGame: any) => matchingGame.GameName === game.name
              // );
              // game.buttonText = matchedGame ? 'Play Now' : 'Add Player';
              if (matchingOffer) {
                game.offer = matchingOffer.Percentage; // Patch the percentage
              }
            });
            this._loaderService.setArrayInLocalStorage(
              'bis_offer',
              this.gameOffers,
            );
          } else {
            this._loaderService.hide();
            this.errorHandling.handleResponseError(response);
          }
        },
        (error) => {
          this._loaderService.hide();
          this.errorHandling.handleHttpError(error);
        },
      );
  }

  loadMoreGames() {
    this.showAllGames = true;
  }

  // Toggle show all / show less
  toggleShowAll() {
    this.showAllGames = !this.showAllGames;
  }

  // whether there are more games than initial visible count
  get hasMoreGames(): boolean {
    return this.filteredGames.length > this.getInitialVisibleCount();
  }
  isMobileScreen: boolean = false;
  isMobile(): boolean {
    return this.isMobileScreen;
  }
  openAddScoreModal(): void {
    this.AddPlayerNameModal = true;
  }
  AddPlayerNameModal: boolean = false;
  closeAddScoreModal(): void {
    this.AddPlayerNameModal = false;
    this.scoreForm.reset();
  }
  gameAccounts: any;

  allowedGames: string[] = [];
  getGameAccount(isAddPlayer: any) {
    const customerID = localStorage.getItem('customerId');
    this.cdr.detectChanges();
    this.cdr.markForCheck();

    const payload = 'Game/GetGameUserInfo?CustomerId=' + customerID;
    this.apiCallService.GetCallWithToken(payload).pipe(takeUntil(this.destroy$)).subscribe(
      (response) => {
        if (response && response.responseCode === 200) {
          this.cdr.detectChanges();
          this.cdr.markForCheck();
          this.gameAccounts = response.data;
          this._loaderService.setArrayInLocalStorage('bis_data', response.data);
          this.allowedGames = this.gameAccounts.map(
            (game: any) => game.GameName,
          );
          this.games.forEach((game: any) => {
            const getPlayerGames = response.data;
            const matchedGame = getPlayerGames.find(
              (matchingGame: any) => matchingGame.GameName === game.name,
            );
            game.buttonText = matchedGame ? 'Play Now' : 'Add Player';
            game.IsOnUpdate = matchedGame ? matchedGame.IsOnUpdate : 'False';
          });
          this.cdr.detectChanges();
          this.cdr.markForCheck();
          if (isAddPlayer != 0) {
            const gameOffer =
              this._loaderService.getArrayInLocalStorage('bis_offer');
            const matchedGameOffer = gameOffer.find(
              (game: any) => game.GameName === isAddPlayer,
            );
            const matchedGame = this.gameAccounts.find(
              (game: any) => game.GameName === isAddPlayer,
            );
            matchedGame.IsOnUpdate = matchedGameOffer
              ? matchedGameOffer.IsOnUpdate
              : 'False';
            this.OnPlayNow(matchedGame);
          }
          this.cdr.detectChanges();
          this.cdr.markForCheck();
        } else {
          this.errorHandling.handleResponseError(response);
          this.cdr.detectChanges();
          this.cdr.markForCheck();
        }
      },
      (error) => {
        this.errorHandling.handleHttpError(error);
        this.cdr.detectChanges();
        this.cdr.markForCheck();
      },
    );
  }
  gamename: any;
  gameimage: any;
  OnPlayNow(details: any): void {
    this.gamename = details.name;
    this.gameimage = details.image;
    if (!this.isToken) {
      this.redirectToSignUp();
      return;
    }

    const matchedGame = this.gameAccounts.find(
      (game: any) =>
        game.GameName === details.name || game.GameName == details.GameName,
    );

    const gameOffer = this._loaderService.getArrayInLocalStorage('bis_offer');
    const matchedGameOffer = gameOffer.find(
      (game: any) =>
        game.GameName === details.name || game.GameName == details.GameName,
    );
    // const specialGames = ['GameVault', 'Juwa', 'Vegas', 'GameRoom'];

    if (matchedGame) {
      matchedGame.IsOnUpdate = matchedGameOffer
        ? matchedGameOffer.IsOnUpdate
        : 'False';
      // Game mil gaya, ab redirect
      localStorage.setItem('GN', matchedGame.GameName);
      this.matchedGameDetails = {
        SerialNumber: matchedGame.SerialNumber,
        PlayerId: matchedGame.PlayerId,
        PlayerName: matchedGame.PlayerName,
        PlayerPassword: matchedGame.PlayerPassword,
        GameName: matchedGame.GameName,
        GameID: matchedGame.GameID,
        IsOnUpdate: matchedGame.IsOnUpdate,
      };

      this.cdr.markForCheck();
      this.cdr.detectChanges();
      this.gameService.setGameData(this.matchedGameDetails);
      this.RedirecttoCredentials();
    } else {
      if (matchedGameOffer?.IsOnUpdate !== 'True') {
        this.OpenAddPlayer(details); //uncomment me

        this.cdr.markForCheck();
        this.cdr.detectChanges();
      } else {
        this.errorHandling.showAlert(
          'warning',
          'Game is under update!. Please try again later.',
        );
        return;
      }
      // this.RedirecttoCredentials(); // comment me

      // Game nahi mila
      // if (specialGames.includes(gameName)) {
      //   this.openAddScoreModal();
      //   this.toastr.info('Player is missing!', 'Info');
      // } else {
      //   this.OpenAddPlayer();
      //   this.toastr.info('Player is missing!', 'Info');
      // }
    }
  }
  croswsIcon = faXmark;
  AddPlayerModal = false;
  CloseAddPlayer() {
    this.AddPlayerModal = false;
  }
  matchedGameDetails: any = null;
  NewPlayerAddPayload: any = {
    id: 0,
    // customerId: this.getCustomerID(),
    // agentcode: '',
    // t: 0,
    // account: '',
    // nickname: '',
    // rechargeAmount: '',
    // login_pwd: '',
    // check_pwd: '',
    // gameName: '',
    // gameUserID: 0,
    gameName: '',
    customerID: this.getCustomerID(),
    playerUserName: '',
    playerPassword: '',
    rechargeBalance: 0,
    gameId: 0,
  };
  OpenAddPlayer(details: any) {
    this.AddPlayerModal = true;
    this.NewPlayerAddPayload.playerUserName = '';
    this.NewPlayerAddPayload.playerPassword = '';
    // this.NewPlayerAddPayload.t = 0;
    // this.NewPlayerAddPayload.account = '';
    // this.NewPlayerAddPayload.agentcode = '';
    // this.payloadaddnewPlayer(details)
    this.NewPlayerAddPayload.gameName = details.name;
    this.NewPlayerAddPayload.id = details.id;
    this.NewPlayerAddPayload.gameId = details.id;
    this.selectedGameData = details;
  }
  selectedGameData: any;
  RedirectToSpinner() {
    this.router.navigate(['/dashboard/spinner']);
  }
  RedirecttoCredentials() {
    this.router.navigate(['/dashboard/credentials']);
  }

  onTabChange(selectedTab: TabItem) {
    this.selectedMainTab = selectedTab.value;

    // Scroll to the section smoothly
    const target = document.getElementById(selectedTab.scrollingId || '');
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
  captchaImages: any;
  onPlayerSubmit() {
    this._loaderService.show();
    const payload = this.NewPlayerAddPayload;
    if (payload.playerUserName == '') {
      payload.playerUserName = this.generateGameAccountIdentifier(
        this.getCustomerName(),
        payload.gameName,
      );
    }
    if (payload.playerPassword == '') {
      this.NewPlayerAddPayload.playerPassword = this.generateGameIdentifier(
        payload.gameName,
      );
    }
    if (this.selectedGameData?.IsOnUpdate == 'True') {
      this.errorHandling.showAlert(
        'warning',
        'Game is under update!. Please try again later.',
      );
      return;
    }
    this.cdr.detectChanges();
    this.cdr.markForCheck();
    this.apiCallService
      .PostCallWithToken(payload, 'AddGameScore/CreatePanelPlayer')
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (response) => {
          if (response && response.responseCode === 200) {
            this.AddPlayerModal = false;
            this.cdr.detectChanges();
            this.cdr.markForCheck();
            // this.CloseCaptchaAddPlayer();
            this.getGameAccount(payload.gameName);
            this._loaderService.hide();
          } else {
            this.errorHandling.handleResponseError(response);
            this.AddPlayerModal = false;
            this._loaderService.hide();
          }
        },
        (error) => {
          this.errorHandling.handleHttpError(error);
          this._loaderService.hide();
          this.AddPlayerModal = false;
        },
      );
  }

  generateGameIdentifier(gameId: any): string {
    let prefix: string = this._utilsService.gameNameInitials(gameId);
    const randomDigits = Math.floor(1000 + Math.random() * 9000); // Generates a random 4-digit number
    const randomLetters =
      String.fromCharCode(97 + Math.floor(Math.random() * 26)) +
      String.fromCharCode(97 + Math.floor(Math.random() * 26)); // Generates 2 random lowercase letters

    // return `${prefix}${randomLetters}${randomDigits}`;
    const combined = `${prefix}${randomLetters}${randomDigits}`;
    return combined.charAt(0).toUpperCase() + combined.slice(1); // Ensure first character is uppercase
  }


  // generateGameAccountIdentifier(CustomerName: string, gameId: any): string {
  //   // 1. Clean the name: Remove anything that isn't a letter or number
  //   // Then take the first 5 chars
  //   let cleanedName = CustomerName.replace(/[^a-zA-Z0-9]/g, () => {
  //     return String.fromCharCode(97 + Math.floor(Math.random() * 26));
  //   });

  //   let prefix: string = cleanedName.slice(0, 5).toLowerCase();

  //   // 2. Pad if shorter than 5
  //   if (prefix.length < 5) {
  //     const charsNeeded = 5 - prefix.length;
  //     for (let i = 0; i < charsNeeded; i++) {
  //       prefix += String.fromCharCode(97 + Math.floor(Math.random() * 26));
  //     }
  //   }

  //   // 3. Get game initials
  //   let gameInitials: string = this._utilsService.gameNameInitials(gameId);

  //   // 4. Generate the 3 random components (2 digits, 1 letter)
  //   const digit1 = Math.floor(Math.random() * 10).toString();
  //   const digit2 = Math.floor(Math.random() * 10).toString();
  //   const letter = String.fromCharCode(97 + Math.floor(Math.random() * 26));

  //   // 5. Place them in an array and shuffle
  //   let components = [digit1, digit2, letter];
  //   for (let i = components.length - 1; i > 0; i--) {
  //     const j = Math.floor(Math.random() * (i + 1));
  //     [components[i], components[j]] = [components[j], components[i]];
  //   }

  //   // 6. Join the shuffled components and return
  //   const randomPart = components.join('');
  //   return `${prefix}${randomPart}${gameInitials}`;
  // }


  generateGameAccountIdentifier(CustomerName: string, gameId: any): string {
    // 1. Clean the name: Replace special characters with random letters
    let cleanedName = CustomerName.replace(/[^a-zA-Z0-9]/g, () => {
      return String.fromCharCode(97 + Math.floor(Math.random() * 26));
    });

    // If username starts with a number,
    // replace first 2 characters with random letters
    if (/^\d/.test(cleanedName)) {
      const randomChar1 = String.fromCharCode(
        97 + Math.floor(Math.random() * 26)
      );
      const randomChar2 = String.fromCharCode(
        97 + Math.floor(Math.random() * 26)
      );

      if (cleanedName.length >= 2) {
        cleanedName =
          randomChar1 +
          randomChar2 +
          cleanedName.slice(2);
      } else {
        cleanedName = randomChar1 + randomChar2;
      }
    }

    // Then take the first 5 chars
    let prefix: string = cleanedName.slice(0, 5).toLowerCase();

    // Pad if shorter than 5
    while (prefix.length < 5) {
      prefix += String.fromCharCode(
        97 + Math.floor(Math.random() * 26)
      );
    }

    // Get game initials
    const gameInitials: string =
      this._utilsService.gameNameInitials(gameId);

    // Generate the 3 random components (2 digits, 1 letter)
    const digit1 = Math.floor(Math.random() * 10).toString();
    const digit2 = Math.floor(Math.random() * 10).toString();
    const letter = String.fromCharCode(
      97 + Math.floor(Math.random() * 26)
    );

    // Shuffle components
    const components = [digit1, digit2, letter];

    for (let i = components.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [components[i], components[j]] = [components[j], components[i]];
    }

    const randomPart = components.join('');

    return `${prefix}${randomPart}${gameInitials}`;
  }
  ///////////////////////////Hitting Hot Games

  HotLottery: any;
  HotSctrach: any;
  HotSpinner: any;
  // While true, the games grid shows skeleton placeholders instead of the
  // blocking full-screen loader that used to cover the whole home page.
  gamesLoading: boolean = true;
  skeletonTiles = Array.from({ length: 10 });

  getGameNews() {
    if (this.isToken) {
      this.cdr.detectChanges();
      this.cdr.markForCheck();
      this.apiCallService
        .GetCallWithToken('TestImonials/GetHotHittingGames')
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (response) => {
            if (response && response.responseCode === 200) {

              this.cdr.detectChanges();
              this.cdr.markForCheck();
              this.gameOffers = response.data;
              this.gamesLoading = false;
              // Assuming `this.games` is the array where you want to patch the Percentage
              this.games.forEach((game: any) => {
                const matchingOffer = this.gameOffers.find(
                  (offer: any) => offer.GameName === game.name,
                );
                if (matchingOffer) {
                  game.isHot = matchingOffer.IsHot;
                  game.bonus = matchingOffer.Bonus;
                  game.IsOnUpdate = matchingOffer.IsOnUpdate || 'False';
                  if (matchingOffer.GameName === 'Spinner') {
                    this.HotSpinner = matchingOffer.IsHot;
                  } else if (matchingOffer.GameName === 'Lottery') {
                    this.HotLottery = matchingOffer.IsHot;
                  } else if (matchingOffer.GameName === 'ScratchCard') {
                    this.HotSctrach = matchingOffer.IsHot;
                  }
                }
              });

              this.cdr.detectChanges();
              this.cdr.markForCheck();
              this._loaderService.setArrayInLocalStorage(
                'bis_offer',
                this.gameOffers,
              );
              this.gameService.triggerUpdatedGames();
            } else {
              this.gamesLoading = false;
              this.cdr.detectChanges();
              this.cdr.markForCheck();
              // this.errorHandling.handleResponseError(response);
            }
          },
          (error) => {
            this.gamesLoading = false;
            this.cdr.detectChanges();
            this.cdr.markForCheck();
            // this.errorHandling.handleHttpError(error);
          },
        );
    } else {
      this.gamesLoading = false;
    }
  }

  trackByGameName(index: number, game: any): any {
    return game.name;
  }
}
